import gql from 'graphql-tag';
import type { IJob } from '../stores/JobStore/Job';
import graphqlClient from 'src/graphql/client';
import { jobInformation } from './fragments/jobInformation.graphql';

export const transformJob = (job: any | null): IJob | null => {
  if (job?.jobInformation) {
    const listingId = parseInt(job.jobInformation.listingId, 10);
    job.jobInformation.listingId = listingId;

    const positionId = parseInt(job.jobInformation.positionId, 10);
    job.jobInformation.positionId = positionId;
    job.positionId = positionId;
  }

  return job;
};
export interface AdvertiserJobAccess {
  accessType: string;
  correctAdvertiserId?: number;
}

const fetchAccessAndJobInformationByPositionId = async (
  positionId: number,
  advertiserId: string,
) => {
  const { data } = await graphqlClient.query({
    variables: { positionId, advertiserId },
    query: gql`
      query AccessAndJobInformationByPositionId(
        $positionId: ID!
        $advertiserId: ID!
      ) {
        advertiserJobAccessByPositionId(
          positionId: $positionId
          advertiserId: $advertiserId
        ) {
          accessType
          correctAdvertiserId
        }
        job(positionId: $positionId, advertiserId: $advertiserId) {
          jobInformation {
            ...jobInformation
          }
        }
      }
      ${jobInformation}
    `,
  });

  const { advertiserJobAccessByPositionId, job } = data;
  return {
    advertiserAccess: advertiserJobAccessByPositionId,
    job: transformJob(job),
  };
};
export default fetchAccessAndJobInformationByPositionId;
